import { render } from "./SvgPhotoCamera.vue?vue&type=template&id=6a57fe86&ts=true"
import script from "./SvgPhotoCamera.vue?vue&type=script&lang=ts"
export * from "./SvgPhotoCamera.vue?vue&type=script&lang=ts"

import "./SvgPhotoCamera.vue?vue&type=style&index=0&id=6a57fe86&lang=css"

import exportComponent from "/builds/knx-core/freightbox/freightbox-monorepo-vue/services/eleos-driver-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__